import moment from 'moment';

export default (user) => {
  if (!user.is_admin && !user.is_agency_admin) {
    throw new Error('You are not authorized for this site.');
  }
  if (user.start_date && !moment().isSameOrAfter(user.start_date, 'day')) {
    const start = moment(user.start_date).format('dddd MMM D, YYYY');
    throw new Error(`You are not authorized for access until ${start}.`);
  }
  if (user.first_login) {
    throw new Error('Please reset your password before first login.');
  }
  if (user.password_expired) {
    throw new Error('Your password has expired.');
  }
};
